export default "__VITE_ASSET__DQKnviIg__"